
export enum SizeEnum {
  Small,
  Medium,
  Large,
  ExtraLarge,
}
